export const FEATURE_FLAGS_REQUESTED = 'featureFlags/FEATURE_FLAGS_REQUESTED';
export const FEATURE_FLAGS_SUCCESS = 'featureFlags/FEATURE_FLAGS_SUCCESS';
export const FEATURE_FLAGS_FAILURE = 'featureFlags/FEATURE_FLAGS_FAILURE';

export interface FeatureFlag {
  key: string;
  enabled: boolean;
}

export interface FeatureFlagsState {
  flags: Record<string, boolean>;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

// Known feature flag keys. Add new flags here to avoid magic strings.
export const FeatureFlagKeys = {
  UkCharity: 'Platform-UK-Charity-UI',
  GiftAidNudge: 'Platform-GiftAid-Nudge-UI',
  SwiftaidConnect: 'Platform-Swiftaid-Connect-UI',
  SwiftaidConnectSysAdmin: 'Platform-Swiftaid-Connect-SysAdmin-UI'
} as const;
